const toText = (value) => {
  if (value === null || value === undefined) return '';
  return String(value).trim();
};

export const hasMeaningfulServiceItems = (serviceItems = []) => {
  if (!Array.isArray(serviceItems) || serviceItems.length === 0) {
    return false;
  }

  return serviceItems.some(item =>
    Array.isArray(item?.services) &&
    item.services.some(service => (
      toText(service?.service ?? service?.serviceName) ||
      toText(service?.quantity) ||
      toText(service?.description) ||
      toText(service?.spec)
    ))
  );
};
